import { render, staticRenderFns } from "./PreviewRecordsSection.vue?vue&type=template&id=02c2fc4e&scoped=true"
import script from "./PreviewRecordsSection.vue?vue&type=script&lang=ts"
export * from "./PreviewRecordsSection.vue?vue&type=script&lang=ts"
import style0 from "./PreviewRecordsSection.vue?vue&type=style&index=0&id=02c2fc4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c2fc4e",
  null
  
)

export default component.exports